import { Accordion, AccordionDetails, AccordionSummary, Skeleton, Stack } from '@mui/material';
import { memo } from 'react';

export const IssueDetailsSkeleton = memo(() => {
  return (
    <Accordion>
      <AccordionSummary expandIcon={<></>} sx={{ minHeight: '4rem' }}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Skeleton height={32} width={40} />
          <Skeleton height={40} width={300} />
        </Stack>
      </AccordionSummary>
      <AccordionDetails></AccordionDetails>
    </Accordion>
  );
});
